import applicationPackage from '../package.json';
import coreVersion from '../node_modules/@keplerco/core/package.json';

export function logAppVersionData(): void {
  console.log('='.repeat(50));
  console.log(`Application Version: ${applicationPackage.version}`);
  console.log(`Core Version: ${coreVersion.version}`);
  console.log('='.repeat(50));
}
